import { render } from "./Claim4_Adm.vue?vue&type=template&id=791f2bd2&scoped=true"
import script from "./Claim4_Adm.vue?vue&type=script&lang=js"
export * from "./Claim4_Adm.vue?vue&type=script&lang=js"

import "./Claim4_Adm.vue?vue&type=style&index=0&id=791f2bd2&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-791f2bd2"

export default script